import type { PrincipleId } from "@chessla/shared";

const PATHS: Record<PrincipleId, string> = {
  center_claim: "M4 12h16M12 4v16m-5-5 5-5 5 5",
  pieces_out: "M4 18 9 6l4 7 3-5 4 10M6 18h12",
  tempo_discipline: "M12 3a9 9 0 1 0 9 9M12 7v5l4 2",
  queen_patience: "M4 18h16l-2-10-4 4-2-7-2 7-4-4-2 10Z",
  pawn_economy: "M8 18h8m-7-3h6l-2-4 2-3-3-3-3 3 2 3Z",
  king_shelter: "M3 12 12 4l9 8v8H3Zm6 8v-5h6v5",
  center_lock: "M7 11h10v9H7Zm2 0V8a3 3 0 0 1 6 0v3",
  rook_harmony: "M3 5h6v5H3Zm12 0h6v5h-6ZM6 10v8h12v-8",
  threat_read: "M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12Zm10-2v5m0 3h.01",
  force_first: "m13 2-8 12h6l-1 8 9-13h-6Z",
  nothing_loose: "M8 8 5 11a4 4 0 0 0 6 6l3-3m2-6 3-3a4 4 0 0 1 0 6l-3 3m-7 3 6-6",
  worst_piece: "M5 19h14M8 16l4-11 4 11m-8-4h8",
  file_control: "M7 3v18m10-18v18M4 7h16M4 17h16",
  outpost: "M6 21V3m1 1h11l-3 4 3 4H7",
  break_timing: "M12 3v7m0 4v7M4 12h5m6 0h5m-3-3 3 3-3 3M7 9l-3 3 3 3",
  pawn_integrity: "M12 3 4 6v6c0 5 3 8 8 9 5-1 8-4 8-9V6Zm-3 9 2 2 4-5",
  clean_conversion: "M4 4h16l-6 7v7l-4 2v-9Zm3 0 5 7 5-7",
  active_king: "M8 20h8l-1-7 3-3-4-2-2-5-2 5-4 2 3 3Zm-5-2 3-3m15 3-3-3",
  opposition: "M4 19h6l-1-7 2-2-3-2-1-4-1 4-3 2 2 2Zm10 0h6l-1-7 2-2-3-2-1-4-1 4-3 2 2 2",
  passer_support: "M5 20h8l-1-5 2-3-3-2-1-4-1 4-3 2 2 3Zm11-2 2 2 4-6",
};

export const PrincipleGlyph = ({ principle }: { principle: PrincipleId }) => (
  <svg aria-hidden="true" viewBox="0 0 24 24" width="82%" height="82%">
    <path
      d={PATHS[principle]}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
  </svg>
);
